"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _reactSortableHoc = require("react-sortable-hoc");

var _Handle = _interopRequireDefault(require("@insided/shared/icons/Handle"));

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _InputGroupWithIcons = _interopRequireDefault(require("@insided/shared/uikit/InputGroupWithIcons"));

var _translations = require("@insided/deprecated-libs/translationsUtils/translations");

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

var _Add = _interopRequireDefault(require("@insided/shared/icons/Add"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var DragHandle = (0, _reactSortableHoc.SortableHandle)(function () {
  return (0, _preact.h)("span", {
    className: "drag-handle"
  }, (0, _preact.h)(_Handle.default, null));
});
var SortableList = (0, _reactSortableHoc.SortableContainer)(function (_ref) {
  var children = _ref.children;
  return children;
});
var SortableItem = (0, _reactSortableHoc.SortableElement)(function (_ref2) {
  var children = _ref2.children;
  return children;
});

var Poll = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(Poll, _Component);

  var _super = _createSuper(Poll);

  function Poll(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Poll);
    _this = _super.call(this, props); // eslint-disable-next-line react/state-in-constructor

    _this.state = {
      newOption: ''
    };
    _this.addNewItemToList = _this.addNewItemToList.bind((0, _assertThisInitialized2.default)(_this));
    _this.updateItemInList = _this.updateItemInList.bind((0, _assertThisInitialized2.default)(_this));
    _this.deleteItemFromList = _this.deleteItemFromList.bind((0, _assertThisInitialized2.default)(_this));
    _this.onItemsSorted = _this.onItemsSorted.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(Poll, [{
    key: "addNewItemToList",
    value: function addNewItemToList() {
      this.props.onChange({
        options: this.props.options.concat([this.state.newOption])
      });
      this.setState({
        newOption: ''
      });
    }
  }, {
    key: "deleteItemFromList",
    value: function deleteItemFromList(idx) {
      var newList = this.props.options;
      newList.splice(idx, 1);
      this.props.onChange({
        options: newList
      });
    }
  }, {
    key: "updateItemInList",
    value: function updateItemInList(newValue, idx) {
      this.props.options[idx] = newValue;
      this.props.onChange({
        options: this.props.options
      });
    }
  }, {
    key: "onItemsSorted",
    value: function onItemsSorted(_ref3) {
      var oldIndex = _ref3.oldIndex,
          newIndex = _ref3.newIndex;
      this.props.onChange({
        options: (0, _reactSortableHoc.arrayMove)(this.props.options, oldIndex, newIndex)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          question = _this$props.question,
          options = _this$props.options,
          _onChange = _this$props.onChange,
          onDelete = _this$props.onDelete;
      var newOption = this.state.newOption;
      return (0, _preact.h)("div", {
        className: "poll-wrapper"
      }, (0, _preact.h)("div", {
        className: "poll-question"
      }, (0, _preact.h)(_InputGroup.default, {
        title: (0, _translations.t)('Forum', 'topic.editor.poll.question.title'),
        placeholder: (0, _translations.t)('Control', 'poll.placeholder.question'),
        type: "text",
        qaClasses: "qa-poll-question",
        onChange: function onChange(e) {
          return _onChange({
            question: e.target.value
          });
        },
        value: question
      })), (0, _preact.h)("div", {
        className: "poll-options"
      }, (0, _preact.h)("strong", null, (0, _translations.t)('Forum', 'topic.editor.poll.answers.title')), (0, _preact.h)(SortableList, {
        useDragHandle: true,
        onSortEnd: this.onItemsSorted
      }, (0, _preact.h)("div", null, options.map(function (item, idx) {
        return (0, _preact.h)(SortableItem, {
          index: idx,
          key: idx
        }, (0, _preact.h)(_InputGroupWithIcons.default, {
          attributes: {
            type: 'text',
            value: item
          },
          className: "qa-poll-option",
          preIcon: (0, _preact.h)(DragHandle, null),
          postIcon: (0, _preact.h)(_Close.default, {
            onClick: function onClick() {
              return _this2.deleteItemFromList(idx);
            }
          }),
          onChange: function onChange(newValue) {
            return _this2.updateItemInList(newValue, idx);
          }
        }));
      }))), (0, _preact.h)(_InputGroupWithIcons.default, {
        attributes: {
          type: 'text',
          value: newOption,
          placeholder: (0, _translations.t)('Forum', 'topic.editor.poll.answers.placeholder')
        },
        className: "qa-poll-add",
        preIcon: (0, _preact.h)(_Add.default, {
          onClick: this.addNewItemToList
        }),
        onEnter: this.addNewItemToList,
        onChange: function onChange(newValue) {
          return _this2.setState({
            newOption: newValue
          });
        }
      })), (0, _preact.h)("div", {
        className: "poll-delete"
      }, (0, _preact.h)("span", {
        className: "poll-delete-link",
        onClick: onDelete
      }, (0, _translations.t)('Forum', 'Remove poll'))));
    }
  }]);
  return Poll;
}(_preact.Component);

var _default = Poll;
exports.default = _default;